// extracted by mini-css-extract-plugin
export default {"wrapper":"DateTime_wrapper__+4Z86","calendar":"DateTime_calendar__ib-or","clock":"DateTime_clock__xshMw"};